"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _toast_notification = _interopRequireDefault(require("./toast_notification"));

require("../css/toast_container.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToastContainer = function ToastContainer(_ref) {
  var children = _ref.children,
      newOnTop = _ref.newOnTop,
      position = _ref.position;
  return _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
    className: "vn-toast-container vn-toast-container--".concat(position)
  }, newOnTop ? _react.default.Children.toArray(children).reverse() : children);
};

ToastContainer.propTypes = {
  position: _propTypes.default.oneOf(['bottom', 'top']),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.oneOf([_toast_notification.default])
  })), _propTypes.default.shape({
    type: _propTypes.default.oneOf([_toast_notification.default])
  })]),
  newOnTop: _propTypes.default.bool
};
ToastContainer.defaultProps = {
  position: 'bottom',
  children: [],
  newOnTop: true
};
ToastContainer.displayName = 'ToastContainer';
var _default = ToastContainer;
exports.default = _default;